import { CreateEntryItem, EntryType, TreeNode } from '@morph-mapper/types';
import { MapApi } from '../types/map';
import { createTreeApi } from './tree';
import { constructPathToIdMapping } from '../utils';
import { err, ok } from 'neverthrow';
import { PluginFrameworkErrorType } from '../types';

export const createMapApi = (entries: Record<string, TreeNode>): MapApi => {
  const treeApi = createTreeApi(entries);
  let mapping = constructPathToIdMapping(entries);

  const isMap = (path: string[]): Boolean => {
    const value = treeApi.getValue(path);
    if (value.isOk() && value.value.type === EntryType.Map) {
      return true;
    }
    return false;
  };

  const hasIterator = (path: string[]) => {
    if (!isMap(path)) {
      return err({
        type: PluginFrameworkErrorType.INVALID_PATH,
        message: 'A Map variable can only be added to a Map.',
      });
    }

    if (!mapping.has(JSON.stringify([...path, '#iterator']))) {
      return ok(false);
    } else {
      return ok(true);
    }
  };

  return {
    addMapVar(path, type, node) {
      if (!isMap(path)) {
        return err({
          type: PluginFrameworkErrorType.INVALID_PATH,
          message: 'A Map variable can only be added to a Map.',
        });
      }

      if (!mapping.has(JSON.stringify([...path, '$declareVariable']))) {
        treeApi.addKey([...path, '$declareVariable'], EntryType.Map, {
          key: '$declareVariable',
          name: '$declareVariable',
        });
      }
      const newpath = path.concat(['$declareVariable', node.key]);
      treeApi.addKey(newpath, type, node);
      return ok();
    },

    removeMapVar(path, key) {
      if (!isMap(path)) {
        return err({
          type: PluginFrameworkErrorType.INVALID_PATH,
          message: 'A Map variable can only be added to a Map.',
        });
      }
      const newpath = path.concat(['$declareVariable', key]);
      treeApi.getValue(newpath).mapErr((error) => {
        return err({ ...error });
      });

      treeApi.removeKey(newpath);
      mapping = constructPathToIdMapping(entries);
      return ok();
    },

    changeMapType(path, newType) {
      if (!isMap(path)) {
        return err({
          type: PluginFrameworkErrorType.INVALID_PATH,
          message: 'A Map type can only be changed for a Map.',
        });
      }

      const value = treeApi.getValue(path);
      if (value.isOk()) {
        let entry = entries[value.value.id];
        if (entry.type === EntryType.Map) {
          entry.formerOutputType = entry.outputType;
          entry.outputType = newType;
        }
        mapping = constructPathToIdMapping(entries);
        return ok();
      }
      return err({ ...value.error });
    },
    addMapIterator(path, type, node) {
      if (!isMap(path)) {
        return err({
          type: PluginFrameworkErrorType.INVALID_PATH,
          message: 'A Map variable can only be added to a Map.',
        });
      }

      const newNode = {
        ...node,
        key: '#iterator',
        name: '#iterator',
      } as Omit<CreateEntryItem, 'parentId'>;

      if //(!hasIterator) {
      (!mapping.has(JSON.stringify([...path, '#iterator']))) {
        treeApi.addKey([...path, '#iterator'], type, newNode);
      } else {
        return err({
          type: PluginFrameworkErrorType.KEY_ALREADY_EXISTS,
          message: 'This map already has an iterator.',
        });
      }
      return ok();
    },
   // hasIterator,
  };
};
